import {
  compileExpression,
  createExpressionMatchTable,
  parseExpression,
  testExpression,
  updateMatchTable,
} from "@skilitics/keyword-search";

import { standardizeString } from "../standardizeString.ts";
import type { ConditionEvaluator } from "../types/conditionEvaluators.ts";
import type { StringCondition } from "../types/conditions/index.ts";
import { Operator } from "../types/operators.ts";
import { createThrowConditionNotImplementedForEvaluator, getSingleValue } from "./common.ts";

const throwNotImplemented = createThrowConditionNotImplementedForEvaluator("string");

export const conditionEvaluator: ConditionEvaluator<StringCondition> = (condition, resolve) => {
  const subject = getSingleValue("string", condition.subject, resolve);
  const object = getSingleValue("string", condition.object, resolve);

  switch (condition.operator) {
    case Operator.EQ:
      return standardizeString(subject) === standardizeString(object);

    case Operator.NE:
      return standardizeString(subject) !== standardizeString(object);

    case Operator.Contains:
      return standardizeString(subject).includes(standardizeString(object));

    case Operator.NotContains:
      return !standardizeString(subject).includes(standardizeString(object));

    case Operator.Matches:
    case Operator.NotMatches: {
      const compiled = compileExpression(object);
      const expression = parseExpression(compiled);

      const matchTable = createExpressionMatchTable(expression);
      updateMatchTable(matchTable, subject);

      const matches = testExpression(expression, matchTable);

      return condition.operator === Operator.Matches ? matches : !matches;
    }

    default:
      return throwNotImplemented(condition);
  }
};

export default conditionEvaluator;
